<template>
  <div style="background-color: #ecf0f4;display: flex;height: 100vh">
    <PageMenu style="background-color: #FFFFFF"/>
    <div style="width: 84%;height: 100vh;display: flex;flex-direction: column;flex: 1">
      <pageHead/>
      <div class="main_box" id="scrollMove">
        <AppMain/>
      </div>
    </div>
    <scrollTop/>
<!--    <guide/>-->
  </div>
</template>

<script>
// import {mapState} from 'vuex'
import {AppMain, PageMenu, PageHead} from './components'
import scrollTop from '../components/scrollTop'
import guide from "../components/guide";
export default {
  name: "index",
  data() {
    return {
      children: [],
      isOpen: false,
      screenWidth: document.body.clientWidth
    }
  },
  components: {
    AppMain,
    PageHead,
    PageMenu,
    scrollTop,
    guide
    // menuTag
  },
  computed: {
    // ...mapState({
    //   PageHead: state => state.app.PageHead,
    //   PageMenu: state => state.app.PageMenu,
    // }),
    // 获取menuChange
    // menuChange(){
    //   return this.$store.state.menuChange
    // }
  },
  created() {
    if (this.$cookies.get('token') && !localStorage.getItem('token')) {
      const token = this.$cookies.get('token');
      const data = this.$cookies.get('userInfo');
      localStorage.setItem('token', token);
      localStorage.setItem('data', JSON.stringify(data));
    }
    // this.getBreadcrumb();
    // this.updateStore(this.screenWidth);
  },
  mounted() {
    // let that=this;
    // window.onresize = () => {
    //   return (() => {
    //     window.screenWidth = document.body.clientWidth;
    //     that.screenWidth = window.screenWidth;
    //     this.updateStore(that.screenWidth)
    //   })()
    // };
    // let route={
    //   name:this.$route.name,
    //   path:this.$route.path,
    // };
    // route.first=localStorage.getItem('platform_first');
    // route.second=localStorage.getItem('platform_second');
    // this.$store.commit('addVisitedView',route)
  },
  methods: {
    // getBreadcrumb() {
    //   this.children = this.$route.matched;
    // },
    //
    // listenSwitch(e) {
    //   this.isOpen = e;
    // },
    // updateStore(val){
    //   if (780>=val){
    //     this.$store.commit('updataMenuType',false);
    //     this.$store.commit('updataCollapse',true)
    //   }else {
    //     this.$store.commit('updataMenuType',true)
    //   }
    //   if (1200>=val){
    //     this.$store.commit('updataCollapse',true)
    //   }
    //   if (val>=1800){
    //     this.$store.commit('updataCollapse',false)
    //   }
    // },
    // menuZoom(type){
    //   this.$store.commit('updataCollapse',type)
    // },
  },
  watch: {
    // "$route": function () {
    // this.children = this.$route.matched;
    // let route={
    //   name:this.$route.name,
    //   path:this.$route.path,
    // };
    // route.first=localStorage.getItem('platform_first');
    // route.second=localStorage.getItem('platform_second');
    // this.$store.commit('addVisitedView',route);
    // },
    // screenWidth(val) {
    //   this.updateStore(val)
    // },
    //监听是否打开项目详情
  },

}
</script>

<style scoped>
.to_app {
  left: 0;
}

.menu_mask {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 8;
  background: rgba(0, 0, 0, 0.5);
}

.main_box {
  width: 95%;
  height: 90vh;
  overflow-y: scroll;
  position: fixed;
  top: 90px;
  left: 310px;
  background-color: #FFFFFF;
}

.container {
  position: absolute;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 314px;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;
  background-color: #F0F2F5;
}

.move {
  transition: all 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue